export default __webpack_public_path__ + "static/media/shoe.6bb4d920.mp4";